@if (groups().length === 0) {
  <p class="placeholder-empty">No placeholders available — declare metadata keys above or have the host app provide an entity catalog.</p>
} @else {
  <div class="placeholder-groups">
    @for (g of groups(); track g.label) {
      <details class="placeholder-group" open>
        <summary>{{ g.label }}</summary>
        <div class="placeholder-chips">
          @for (t of g.tokens; track t.insert) {
            <button type="button" class="chip" (click)="onPick(t.insert)" title="Insert {{ t.insert }}">
              {{ t.display }}
            </button>
          }
        </div>
      </details>
    }
  </div>
}
